import ApplicationSerializer from 'eflex/serializers/application';

export default class KineticPartRevSerializer extends ApplicationSerializer {
  attrs = {
    operations: {
      deserialize: false,
      serialize: false,
    },
  };
}
